import { render } from "./index.vue?vue&type=template&id=376b4fb6"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/pages/price_bundles/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "376b4fb6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('376b4fb6', __exports__)) {
    console.log('reload')
    api.reload('376b4fb6', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=376b4fb6", () => {
    console.log('re-render')
    api.rerender('376b4fb6', render)
  })

}


export default __exports__